/**
 * Cloudflare Images (`imagedelivery.net`) expects a variant segment (e.g. `/w=800`). Stored
 * `assetUrl` values are often only `…/accountHash/imageId` (two path segments), which returns
 * “malformed URL” in a browser. Strips `/public` (same as native `getResolutionUrl`) then appends
 * a flexible-width variant only when the path still has exactly those two segments.
 */
export function resolveCloudflareImagesUrlForWeb(
  url: string,
  maxWidth: 260 | 400 | 800 | 1200,
): string {
  const trimmed = url.trim();
  if (!trimmed || !trimmed.includes('imagedelivery.net')) {
    return trimmed;
  }

  let base = trimmed.replace('/public', '');
  base = base.replace(/\/+$/, '');

  try {
    const { pathname } = new URL(base);
    const segments = pathname.split('/').filter(Boolean);
    if (segments.length === 2) {
      return `${base}/w=${maxWidth}`;
    }
    return base;
  } catch {
    return base;
  }
}
